export default __webpack_public_path__ + "static/media/googleMapIcon.16d017dc.png";